import React from "react";

import { faCircleExclamation } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../Icon";

export const IconError = () => {
	return (
		<div className="rounded-full bg-red-1 p-2">
			<Icon icon={faCircleExclamation} size={24} color="red-5" />
		</div>
	);
};
